import React, { Component } from 'react';
import {Paper} from 'material-ui';

const Pane = props =>
  <div style={{padding: '5px'}}>
    <div style={{paddingLeft: '10px'}}>{props.label}</div>
    {props.children}
  </div>;

export default Pane;
